import {CSSProperties} from 'react'
import styled, {css} from 'styled-components'

export const StyledMenuContainer = styled.div<{$isOpen: boolean; $width?: CSSProperties['width']}>(
    ({theme: {palette, shadows}, $isOpen, $width}) => css`
        position: fixed;
        background-color: ${palette.neutral['25']};
        border-radius: 8px;
        box-shadow: ${shadows.lg};
        border: 1px solid ${palette.neutral['200']};
        overflow: hidden;
        display: ${$isOpen ? 'block' : 'none'};
        width: ${$width};
    `
)

export const StyledMenuGroup = styled.div(
    ({theme: {spacing, palette}}) => css`
        padding: ${spacing}px;
        width: 100%;
        &:not(:last-child) {
            margin-bottom: ${spacing}px;
            border-bottom: 1px solid ${palette.neutral['200']};
        }
    `
)

export const StyledMenuItem = styled.button<{$variant?: 'neutral' | 'danger'}>(
    ({theme: {palette, spacing, transition, typography}, $variant = 'neutral'}) => css`
        cursor: pointer;
        width: 100%;
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;
        padding: ${spacing * 1.5}px ${spacing * 2}px;
        transition: ${transition};
        ${typography.textSm};
        color: ${$variant == 'danger' ? palette.danger['500'] : palette.neutral['950']};
        & > svg {
            width: 16px;
            height: 16px;
            fill: ${$variant == 'danger' ? palette.danger['500'] : palette.neutral['500']};
        }

        &:hover {
            background-color: ${palette.neutral['100']};
        }
    `
)
